export default __webpack_public_path__ + "static/f10-416c1f2d438f0b67edc904c817701c97.svg";